export const getDynamicMenuPosition = ({
  coords,
  maxHeight,
  maxWidth,
  containerRect = document.documentElement.getBoundingClientRect(),
  prevPlacement = null,
}) => {
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;
  const spaceBelow = viewportHeight - coords.bottom;
  const spaceAbove = coords.top;
  let placement = 'bottom';
  if (!prevPlacement) {
    placement = spaceBelow >= maxHeight || spaceBelow > spaceAbove ? 'bottom' : 'top';
  } else {
    placement = prevPlacement;
  }
  let top = placement === 'bottom' ? coords.bottom : coords.top - maxHeight;
  if (top < containerRect.top) top = containerRect.top;
  if (top + maxHeight > viewportHeight) top = viewportHeight - maxHeight;

  let left = coords.left;
  if (left + maxWidth > viewportWidth) {
    left = viewportWidth - maxWidth - 8;
  }

  return {
    top,
    left,
    placement,
  };
};

export default getDynamicMenuPosition;
